import { render } from "./BookingNotesModal.vue?vue&type=template&id=c802868e&scoped=true"
import script from "./BookingNotesModal.vue?vue&type=script&lang=js"
export * from "./BookingNotesModal.vue?vue&type=script&lang=js"

import "./BookingNotesModal.vue?vue&type=style&index=0&id=c802868e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c802868e"]])

export default __exports__